import { AppSidebar } from "@/components/nav/AppSideBar"

import {
  SidebarInset,
  SidebarProvider,
} from "@/components/ui/sidebar"
import { Outlet, useLocation, Link } from "react-router"
import { cn } from "@/lib/utils"
import React from "react"
import { UserProvider } from "@/contexts/UserContext"
import { useUser } from "@/hooks/useUser"
import type { CurrentUser, CurrentUserFull } from "@/types/index"
import { Loader2 } from "lucide-react"
import { useNavigate } from "react-router"
import { MobileTopNav } from "@/components/nav/MobileTopNav";

export default function AppLayout() {
  return (
    <UserProvider>
      <AppLayoutContent />
    </UserProvider>
  );
}

function AppLayoutContent() {
  const navigate = useNavigate();

  // Use current user from context
  const { currentUser, isLoadingUser } = useUser();

  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(Boolean);

  // Convert path segments to readable titles
  const getReadableTitle = (segment: string) => {
    if (segment === 'org') return 'Organisation';
    return segment.charAt(0).toUpperCase() + segment.slice(1);
  };

  if (isLoadingUser) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
        <span className="ml-2">Loading user data...</span>
      </div>
    );
  }

  if (!currentUser) {
    navigate('/logout');
    return null;
  }

  return (
    <SidebarProvider>
      <AppSidebar currentUser={currentUser} />
      <SidebarInset className={cn(
        "w-full max-w-full",
        "md:peer-data-[variant=inset]:m-0"
      )}>
        <div className="w-full max-w-full md:p-6 lg:p-8">
          <MobileTopNav />
          <main className="p-4">
            <Outlet />
          </main>
        </div>
      </SidebarInset>
    </SidebarProvider>
  );
}

